import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {
    addNewRowToTable,
    convertUniversalDateTimeToPersianDateTime, DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCardInfoTypeOne, RaikoCardInfoTypeOneGridTypeItems,
    RaikoCardInfoTypeOneItemGenerator,
    RaikoCardInfoTypeOneStatusTypes, RaikoCustomSimpleActiveDeActiveChip,
    RaikoCustomTable, RaikoDefaultDialogPage,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoTableTitleContainer, showServerErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import {CampaignsService} from "../../serverService/campaigns/CampaignsService";
import AddNewCampaign from "../../serverService/campaigns/addNewCampaign/AddNewCampaign";
import {useNavigate} from "react-router-dom";


export default function Campaigns() {

    let page = 0
    const size = 15

    const service = new CampaignsService()


    const [selectDisplayType, setSelectDisplayType] = useState(false);
    const [campaignsData, setCampaignsData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [tableLoadingState, setTableLoadingState] = useState(false);
    const [numberOfItems, setNumberOfItems] = useState(0);


    useEffect(() => {
        if (typeof service !== 'undefined') {
            getCampaignsListFromData()
        }
    }, []);


    function tableCampaignsPreparation(
        id,
        number,
        title,
        startDate,
        endDate,
        slug,
        acceptation,
        automaticAcceptance,
        maximumNumberOfRegistrationsAllowed,
        createdBy,
        createdAt,
        enabled
    ) {

        return {
            id,
            number,
            title,
            startDate: convertUniversalDateTimeToPersianDateTime(startDate),
            endDate: convertUniversalDateTimeToPersianDateTime(endDate),
            slug,
            acceptation,
            automaticAcceptance,
            maximumNumberOfRegistrationsAllowed,
            createdBy,
            createdAt: convertUniversalDateTimeToPersianDateTime(createdAt),
            enabled: <RaikoCustomSimpleActiveDeActiveChip state={enabled} activeStateTitle={"فعال"}
                                                          deActiveStateTitle={"غبر فعال"}/>
        }
    }


    function getCampaignsListFromData() {
        setTableLoadingState(true)
        service.getCampaignsList(page, size)
            .then(response => {
                setPageCount(response.totalPage)
                setNumberOfItems(response.numberOfItems)
                setCampaignsData([])
                response.data.map((item, index) => {
                    setCampaignsData(prevState => [
                        ...prevState,
                        tableCampaignsPreparation(
                            item.id,
                            (page * size) + index + 1,
                            item.title,
                            item.startDate,
                            item.endDate,
                            item.slug,
                            item.acceptation,
                            item.automaticAcceptance,
                            item.maximumNumberOfRegistrationsAllowed,
                            item.createdBy,
                            item.createdAt,
                            item.enabled,
                        )

                    ])
                })
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setTableLoadingState(false)
        })
    }

    function handleChangePagination(newPage) {
        page = newPage
        getCampaignsListFromData()
    }

    const [openAddNewCampaignDialog, setOpenAddNewCampaignDialog] = useState(false)

    function handleOpenDialog() {
        setOpenAddNewCampaignDialog(true)
    }

    function handelCloseDialog() {
        setOpenAddNewCampaignDialog(false)
    }

    function handleAddNewCampaignsToTable(item) {
        let newRow = addNewRowToTable(
            tableCampaignsPreparation(
                item.id,
                1,
                item.title,
                item.startDate,
                item.endDate,
                item.slug,
                "-",
                "-",
                "-",
                "-",
                "-",
                "-",
            ),
            campaignsData
        );
        setCampaignsData(newRow)

    }

    const navigate = useNavigate()

    function handleShowCampaignDetails(campaignId) {
        let _title = ""
        campaignsData.map((item) => {
            if (item.id === campaignId)
                _title = item.title
        })

        navigate(RouteHelper.CampaignDetails.globalUrl.replace(":id", campaignId),
            {state: {title: _title}, replace: false}
        )
    }


    return (
        <>
            <Helmet><title>{RouteHelper.Campaigns.name}</title></Helmet>
            <RaikoDefaultDialogPage
                onClose={handelCloseDialog}
                open={openAddNewCampaignDialog}
                dialogSize={DialogSize.WRAP_CONTENT}
                hasCloseButton={false}
            >
                <AddNewCampaign
                    handleCloseDialog={handelCloseDialog}
                    handleAddNewCampaign={handleAddNewCampaignsToTable}
                />
            </RaikoDefaultDialogPage>


            <RaikoBaseContainer>
                <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                    <RaikoBreadcrumb
                        breadCrumbItems={[
                            raikoBreadCrumbItemGenerator(
                                "گردشگری",
                                ""
                            ),
                            raikoBreadCrumbItemGenerator(
                                RouteHelper.Campaigns.name,
                                ""
                            ),
                        ]}/>
                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={RouteHelper.Campaigns.name}
                                amount={numberOfItems}
                                hasSelectDisplayType
                                selectDisplayType={selectDisplayType}
                                setSelectDisplayType={setSelectDisplayType}
                                hasCreateNewItem
                                handleCreateNewItem={handleOpenDialog}
                            />
                            <RaikoCustomTable
                                header={campaignsTableHeader}
                                data={campaignsData}
                                isLoading={tableLoadingState}
                                pageCount={pageCount}
                                handlePaginationChange={handleChangePagination}
                                selectDisplayType={selectDisplayType}
                                rowClicked={handleShowCampaignDetails}
                            >
                                <RaikoGridTwoColumn className={css`padding: 3px;`}>
                                    {
                                        campaignsData.map((item, index) => {
                                            return <RaikoCardInfoTypeOne
                                                key={index}
                                                iconClass={"ic-ambulance"}
                                                title={item.title}
                                                status
                                                statusType={item.enabled ? RaikoCardInfoTypeOneStatusTypes.SUCCESS : RaikoCardInfoTypeOneStatusTypes.ERROR}
                                                statusText={item.enabled ? "فعال" : "غیر فعال"}
                                                items={[
                                                    RaikoCardInfoTypeOneItemGenerator("تاریخ شروع", item.startDate),
                                                    RaikoCardInfoTypeOneItemGenerator("تاریخ پایان", item.endDate),
                                                    RaikoCardInfoTypeOneItemGenerator("تاریخ ساخت", item.createdAt ? item.createdAt : "-"),
                                                    RaikoCardInfoTypeOneItemGenerator("سازنده", item.createdBy ? item.createdBy : "-"),
                                                ]}
                                                gridTypeItems={RaikoCardInfoTypeOneGridTypeItems.TWO_COLUMN}
                                                onClick={() => {
                                                    handleShowCampaignDetails(item.id)
                                                }}
                                            />
                                        })
                                    }

                                </RaikoGridTwoColumn>
                            </RaikoCustomTable>
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>

                </RaikoGridOneColumn>
            </RaikoBaseContainer>

        </>
    )
}

const campaignsTableHeader = [
    {
        id: "number",
        label: "#",
    },
    {
        id: "title",
        label: "عنوان پویش",
    },
    {
        id: "startDate",
        label: "تاریخ شروع",
    },
    {
        id: "endDate",
        label: "تاریخ پایان",
    },
    {
        id: "slug",
        label: "slug",
    },
    {
        id: "acceptation",
        label: "پذیرش",
    },
    {
        id: "automaticAcceptance",
        label: "پذیرش خودکار",
    },
    {
        id: "maximumNumberOfRegistrationsAllowed",
        label: "حداکثر تعداد ثبت نام مجاز",
    },
    {
        id: "createdBy",
        label: "سازنده",
    },
    {
        id: "createdAt",
        label: "تاریخ ساخت",
    },
    {
        id: "published",
        label: "انتشار",
    },
    {
        id: "enabled",
        label: "وضعیت",
    },

]